


































import Vue from "vue"
import FormErrorMessage from "~/components/guideline/form/local/FormErrorMessage.vue"
import color from "~/config/color"

export default Vue.extend({
  components: {
    FormErrorMessage,
  },
  props: {
    // **注意** : valueは呼び出し元では :value ではなく、 v-model に設定すること。
    // 本コンポーネントは value を v-model に設定することで、値の更新処理を実行するようになっている。
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    keyColor() {
      return color.keyColor
    },
  },
  methods: {
    updateCheckbox(value: boolean) {
      this.handleInput(value)
    },
    toggleValue(): void {
      this.handleInput(!this.value)
    },
    handleInput(newValue: boolean) {
      // 呼び出し元の v-model で値を受け取り、 value が更新される。
      this.$emit("input", newValue)
    },
  },
})
